var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("dominacao-imovel", {
        attrs: { required: true, imovel: _vm.cadastro.imovel }
      }),
      _c("matricula-titulo-imovel", {
        attrs: { imovel: _vm.cadastro.imovel, titulo: "Dados do registro" }
      }),
      _c("app-documentos", {
        attrs: {
          maxSize: 25000,
          "valid-extensions": ["pdf", "rar", "zip"],
          documentos: _vm.cadastro.imovel.documentos,
          tiposDocumentos: _vm.documentos,
          tiposDocumentosObrigatorios: _vm.documentosObrigatorios,
          observer: _vm.observer,
          aba: "Imóvel",
          validateRule: "documentosObrigatorios"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a80a325", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a80a325","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/maranhao/processoFisico/components/Imovel.vue
// module id = null
// module chunks = 